var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{'active-sidebar' : this.sidebar.is_active}},[_c('div',{staticClass:"TVChartContainer",class:{'no-sidebar' : !this.sidebar.enable},attrs:{"id":_vm.container}})])}
var staticRenderFns = []

export { render, staticRenderFns }